import { IconAction } from '@tkww/orion-web-ds-action';
import type { NavigationButtonProps } from '@xo-union/ui-carousel';
import classNames from 'classnames';
import React from 'react';
import Styles from './carousel-buttons.scss';

export const NextButton = ({
	className,
	onClick,
	...props
}: NavigationButtonProps) => {
	return (
		<div className={Styles.iconWrapper} aria-roledescription="next button">
			<IconAction
				className={classNames(className, Styles.nextButton)}
				{...props}
				name="caret-right"
				onClick={onClick}
				size="md"
			/>
		</div>
	);
};

export const PrevButton = ({
	className,
	onClick,
	...props
}: NavigationButtonProps) => {
	return (
		<div className={Styles.iconWrapper} aria-roledescription="previous button">
			<IconAction
				className={classNames(className, Styles.previousButton)}
				{...props}
				name="caret-left"
				onClick={onClick}
				size="md"
			/>
		</div>
	);
};
